const WEPLOYEE_TOKEN_LOCAL_STORAGE_NAME = 'weployeeTokenExpiry';
const WEPLOYEE_DETAILS_STORAGE_NAME = 'weployeeDetails';
const WEPLOYER_DETAILS_STORAGE_NAME = 'weployerDetails';

const useInMemoryStorage = self => ({
  /*
  Safari throws a security-related exception if you try to store
  values in localStorage in a private tab. When values are
  stored in memory they will not persist between reloads and tabs,
  but this implementation will be sufficient to prevent the error
  being thrown.
  */
  setItem: (value) => {
    self.value = value; // eslint-disable-line no-param-reassign
  },
  getItem: () => self.value,
  removeItem: () => {
    self.value = null; // eslint-disable-line no-param-reassign
  },
});

const useLocalStorage = self => ({
  setItem: value => localStorage.setItem(self.itemName, JSON.stringify(value)),
  getItem: () => JSON.parse(localStorage.getItem(self.itemName)),
  removeItem: () => localStorage.removeItem(self.itemName),
});

const storage = (itemName) => {
  const isLocalStorageSupported = () => {
    try {
      const testKey = '__test__';
      localStorage.setItem(testKey, testKey);
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  };

  const self = {
    itemName,
    localStorageSupported: isLocalStorageSupported(),
    value: null,
  };
  Object.assign(self, self.localStorageSupported ? useLocalStorage(self) : useInMemoryStorage(self));
  return self;
};

export const weployeeTokenExpiryStorage = storage(WEPLOYEE_TOKEN_LOCAL_STORAGE_NAME);
export const weployeeDetailsStorage = storage(WEPLOYEE_DETAILS_STORAGE_NAME);
export const weployerDetailsStorage = storage(WEPLOYER_DETAILS_STORAGE_NAME);

export default {
  weployeeTokenExpiryStorage,
  weployeeDetailsStorage,
  weployerDetailsStorage,
};
